var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66669 8C1.66669 4.134 4.80069 1 8.66669 1C12.5326 1 15.6667 4.134 15.6667 8C15.6667 11.866 12.5326 15 8.66669 15C4.80069 15 1.66669 11.866 1.66669 8ZM5.86669 6.6C5.86669 6.2134 6.18009 5.9 6.56669 5.9H10.7667C11.1533 5.9 11.4667 6.2134 11.4667 6.6C11.4667 6.98661 11.1533 7.3 10.7667 7.3H6.56669C6.18009 7.3 5.86669 6.98661 5.86669 6.6ZM5.86669 9.4C5.86669 9.01339 6.18009 8.7 6.56669 8.7H10.7667C11.1533 8.7 11.4667 9.01339 11.4667 9.4C11.4667 9.78661 11.1533 10.1 10.7667 10.1H6.56669C6.18009 10.1 5.86669 9.78661 5.86669 9.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintain);
export default __webpack_public_path__ + "static/media/maintain.c7a18866f2e5bbbfb2c51cd2fdeeefa7.svg";
export { ForwardRef as ReactComponent };